import { Text } from '@mantine/core';
import { IconReport } from '@tabler/icons-react';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { URL_PREFIX } from '../../constants/stores';
import { BolData } from '../../interface/BillOfLading';
import { addDaysToDate } from '../../Utils/getDaybyDate';
import { getCorporateNo, getStoreInfo } from '../../Utils/utils';

// client\public\svp_sports_drk_blue.png
import { getStores } from '../../api/storeApi';
import logo from './logo_g2000.png';
(pdfMake.vfs as any) = pdfFonts.vfs;

interface GenerateInvoiceProps {
    bol: BolData;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    variant?: 'default' | 'outline' | 'light' | 'filled';
    textElement?: string;
}
const convertImageToBase64 = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
const GenerateInvoice: React.FC<GenerateInvoiceProps> = ({ bol, size, variant, textElement }) => {

    const token = useSelector((state: any) => state.user.sessionId);
    const user = useSelector((state: any) => state.user.user);
    const [invoice, setInvoice] = useState<string>('');
    const [billInfo, setBillInfo] = useState<any>();
    const [storeList, setStoreList] = useState<any[]>([]);
    // const logo = './letter_head.png';
    const handlePrintInvoice = async () => {
        try {
            if (!bol) {
                alert('Can not find the data.');
                return;
            }
            // const getInfo = await getLocationInfo(undefined, undefined, bol?.receiver?.name);
            // setBillInfo(getInfo);
            if (!bol.invoice_no) {
                await generateInvoice();
            }
            generatePDF();
        } catch (error) {
            console.log(`Error :`, error);
        }
    }
    const generateInvoice = async () => {
        try {
            const response = await fetch(`${URL_PREFIX}/bol/generateInvoice`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ bol_no: bol.bol_no })
            });
            const { data, message } = await response.json();
            if (response.status !== 200) {
                alert(message);
                return;
            }
            alert(message);
            setInvoice(data.invoice_no);
        } catch (error) {
            alert('Error generating invoice');
            console.log('Error in generateInvoice: ', error);
        }
    }
    useEffect(() => {
        getStores().then((data) => {
            setStoreList(data);
        }).catch((error) => { console.log(error) })
    }, [])
    const generatePDF = async () => {
        const imageDataUrl = await convertImageToBase64(logo);
        // const shippingDetails = getLocationInfo(user.location);
        const receiverDetails = getStoreInfo('name', bol.receiver?.name ?? '', storeList);
        const corporateNo = bol.corporation_no || '2138398 ONTARIO INC.';
        let contentData: any[] = [
            {
                table: {
                    widths: [310, 200],
                    body: [
                        [
                            {
                                table: {
                                    widths: [285],
                                    body: [
                                        [{ text: 'G2000 EXPRESS INC', style: 'title' }],
                                        [{ text: '1130 CALEDONIA ROAD \n NORTH RORK, ON, M6A 2W5 \n Phone# 416-243-8590 Fax# 888-867-2208 \n elmo@g2000express.com \n HST/GST# 871 539 144 RT 0001', style: 'data' }],
                                    ]
                                },
                                margin: [0, 0, 0, 0],
                                layout: {
                                    defaultBorder: false,
                                }
                            },
                            {
                                image: imageDataUrl,
                                alignment: 'center',
                                border: true,
                                margin: [0, 0, 0, 0],
                                fit: [180, 200], // Add this property to specify the image size
                                style: 'redBackground'
                            }
                        ],
                        [
                            { text: 'Invoice To:', bold: true, border: [false, false, false, false] },
                            { text: 'Invoice', bold: true, fontSize: 16, alignment: 'right', border: [false, false, false, false] },
                        ],
                        [
                            {
                                table: {
                                    widths: [285],
                                    body: [
                                        [{ text: `${corporateNo ?? ''} / SVP SPORTS`, style: 'title' }],
                                        [{ text: `${receiverDetails?.address} \n ${receiverDetails?.city} \n Phone#: ${receiverDetails?.contact ? receiverDetails?.contact[0]?.phone ?? '' : ''}`, style: 'data' }],
                                    ]
                                },
                                margin: [0, 0, 0, 0],
                                layout: {
                                    defaultBorder: false,
                                }
                            },
                            {
                                table: {
                                    headerRows: 1,
                                    widths: [60, 90],
                                    body: [
                                        [{ text: 'Invoice#:', style: 'title', border: [true, true, false, false] }, { text: bol?.invoice_no, style: 'data', border: [false, true, true, false], }],
                                        [{ text: 'Date:', style: 'title', border: [true, false, false, true] }, { text: `${bol.bol_date?.split('T')[0] ?? ''}`, style: 'data', border: [false, false, true, true] }],
                                    ],
                                },
                                alignment: 'right',
                                margin: [35, 0, 0, 0],
                                border: [false, false, false, false]
                            },
                        ],
                        [
                            // { text: `Order# ${bol?.bol_no} Dated ${new Date().toLocaleDateString('en-CA')?.split('T')[0]}`, bold: true, border: [false, false, false, false] },
                            { text: `Order# ${bol?.bol_no} Dated ${bol?.updated_at?.split('T')[0]}`, bold: true, border: [false, false, false, false] },
                            { text: `Truck#               Trailer#`, alignment: 'left', border: [false, false, false, false] },
                        ],
                        [{
                            table: {
                                headerRows: 1,
                                widths: [30, 137, 60, 137, 60, 50],
                                body: [
                                    // Header Row
                                    [{ text: 'Item', style: 'title', alignment: 'left' },
                                    { text: 'Shipper', style: 'title', alignment: 'left' },
                                    { text: 'Pick-up Date', style: 'title', alignment: 'left' },
                                    { text: 'Consignee', style: 'title', alignment: 'left' },
                                    { text: 'Delivery Date', style: 'title', alignment: 'left' },
                                    { text: 'Amount', style: 'title', alignment: 'left' }],

                                    // Data Row
                                    [{ text: `${bol?.po?.reduce((total, item) => total + item.skid, 0)} Skids`, style: 'data', alignment: 'left' },
                                    { text: `${bol.shipper?.name} \n ${bol?.shipper?.address} \n ${bol?.shipper?.postal_code}`, style: 'data', alignment: 'left' },
                                    { text: `${bol.bol_date?.split('T')[0] ?? ''}`, style: 'data', alignment: 'left' },
                                    { text: `${bol.receiver?.name} \n ${bol?.receiver?.address} \n ${bol?.receiver?.postal_code}`, style: 'data', alignment: 'left' },
                                    { text: `${bol.bol_date?.split('T')[0] ?? ''}`, style: 'data', alignment: 'center' },
                                    { text: `${bol?.amount ?? '0'}.00`, style: 'data', alignment: 'center' }]
                                ],
                                heights: function (rowIndex: number, node: any) {
                                    if (rowIndex === 0) return 20;  // Set height for the header row
                                    if (rowIndex === 1) return 330;  // Set height for the data row
                                    return 'auto';  // Allow auto-height for other rows
                                }
                            },
                            margin: [-5, 0, 0, 0],
                            colSpan: 2,
                            border: [false, false, false, false]
                        }
                            , {
                        }],
                        [{
                            table: {
                                // headerRows: 1,
                                widths: [50, 200],
                                body: [
                                    // Data Row
                                    [{ text: `Terms:`, style: 'data', alignment: 'left' },
                                    { text: `30 Days`, style: 'data', alignment: 'left' }],
                                    [{ text: `Due Date:`, style: 'data', alignment: 'left' },
                                    { text: `${addDaysToDate(bol?.bol_date ?? '', 30)}`, style: 'data', alignment: 'left' }],
                                    [{ text: `Thank you for your business.`, style: 'data', alignment: 'left', colSpan: 2 },
                                    {}],
                                ],
                            },
                            margin: [-5, 0, 0, 0],
                            border: [false, false, false, false],
                            layout: {
                                defaultBorder: false
                            }
                        }, {
                            table: {
                                // headerRows: 1,
                                widths: [115, 50],
                                body: [
                                    // Data Row
                                    [{ text: `Sub-Total (CAD$)`, style: 'data', alignment: 'left', bold: true },
                                    { text: `${bol?.amount ?? '0'}.00`, style: 'data', alignment: 'center' }],
                                    [{ text: `HST/GST (13%)`, style: 'data', alignment: 'left', bold: true },
                                    {
                                        text: `${new Intl.NumberFormat('en-IN', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }).format((bol?.amount ?? 0) * 0.13)}`,
                                        style: 'data',
                                        alignment: 'center',
                                    },],
                                    [{ text: ' ' }, { text: ' ' }],
                                    [{ text: `Total Amount (CAD$)`, style: 'data', alignment: 'left', bold: true },
                                    {
                                        text: `${new Intl.NumberFormat('en-IN', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }).format((bol?.amount ?? 0) * 1.13)}`,
                                        style: 'data',
                                        alignment: 'center',
                                        border: [false, true, false, true],
                                    },],
                                ],
                            },
                            margin: [20, 0, 0, 0],
                            border: [false, false, false, false],
                            layout: {
                                defaultBorder: false
                            }
                        }],
                    ],
                },
                margin: [25, 20, 0, 0],
                layout: {
                    defaultBorder: true,
                },

            },
        ];

        // border the entire page
        const docDefinition: TDocumentDefinitions = {
            content: contentData,
            pageSize: 'LETTER',
            pageMargins: [5, 5, 5, 5],
            pageOrientation: 'portrait',
            styles: {
                tabe: {
                },
                header: {
                    fillColor: '#04162e',
                    color: 'white',
                    fontSize: 10,
                    bold: true,
                    alignment: 'center'
                },
                body: {
                    color: 'black',
                    fontSize: 15,
                    alignment: 'center'
                },
                title: {
                    // fillColor: '#04162e',
                    color: 'black',
                    fontSize: 13,
                    bold: true,
                    alignment: 'left',
                },
                data: {
                    fontSize: 10,
                    bold: false,
                    alignment: 'left'
                },
            },
            background: [
                {
                    // Draw a border around the page
                    canvas: [
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: 500,  // A4 width
                            h: 800,  // A4 height
                            lineWidth: 5,
                            lineColor: 'black',
                            fillOpacity: 0,
                        }
                    ]
                },
            ],
            watermark: {
                // Combine text with line breaks
                text: bol?.approval ? `Approved by ${bol?.approved_by?.name ?? 'NONE'} ${new Date(bol?.approved_by?.date ?? Date.now()).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}                              ` : '',
                color: 'red',
                opacity: 0.6,
                bold: true,
                fontSize: 30,
                angle: -45,
                // alignment: 'center', // Centers watermark text
            }
        };

        pdfMake.createPdf(docDefinition).open();
    };

    return (
        <div style={{ cursor: 'pointer' }}>
            {textElement ?
                (<Text className={'linkText'} onClick={handlePrintInvoice} size={size || 'sm'} fw={650} fz={14}> {textElement}</Text>) :
                invoice !== '' ? (<Text className={'linkText'} onClick={handlePrintInvoice} size={size || 'sm'} fw={650} fz={14}> {invoice}</Text>) :
                    (<Text className={'linkText rowDiv'} onClick={handlePrintInvoice} size={size || 'sm'} fw={650} fz={14}> GENERATE<IconReport /></Text>)
                // (<Button className={'btn'} onClick={handlePrintInvoice} size={size || 'sm'} variant={variant || 'default'}> <IconPlus />Generate</Button>)
            }
        </div>
    )
}

export default GenerateInvoice;